import { FJ180 } from '../../services/j209Api';

export const isApproved = (record: FJ180 | null): boolean => {
  return record?.fj180_80 === 'P';
};

export const getStatusBadge = (record: FJ180 | null): { text: string; cls: string } | null => {
  if (!record) return null;
  if (record.fj180_80 === 'P') {
    return { text: '已核准', cls: 'badge-success' };
  }
  return null;
};

export const dateToInput = (v: string | null | undefined): string =>
  v ? String(v).substring(0, 10) : '';

export const inputToDate = (v: string): string | null =>
  v ? v + 'T00:00:00Z' : null;
